import { useLocation } from 'react-router-dom';
import { PRIVATE_ROUTES_COMPLETE } from '@/navigation/privateRoutes';

export const useCurrentRouteTitle = (): string | null => {
  const location = useLocation();
  const pathSegment = location.pathname.split('/').filter(Boolean).pop();

  for (const route of Object.values(PRIVATE_ROUTES_COMPLETE)) {
    if ('navigation' in route && route.navigation === pathSegment) {
      return route.title;
    }

    if ('sections' in route && Array.isArray(route.sections)) {
      const section = route.sections.find(s => s.navigation === pathSegment);
      if (section) return section.title;
    }
  }

  return null;
};
